import React from 'react'
import PropTypes from 'prop-types'
import { TwitterPicker } from 'react-color'
import styles from './styles.module.scss'

const ColorPicker = ({ showColorPicker, setShowColorPicker, colors, color, setColor }) => {
  const handleClose = () => {
    setShowColorPicker()
  }
  const handleChange = (selectedColor) => {
    setColor(selectedColor)
  }
  const twitterStyle = {
    default: {
      input: {
        display: 'none'
      },
      hash: {
        display: 'none'
      }
    }
  }
  return (
    <div className={styles.colorPickerWrapper}>
      {showColorPicker ? (
        <div className={styles.popover}>
          <div className={styles.cover} onClick={handleClose} />
          <TwitterPicker width={205} onChange={handleChange} color={color} colors={colors} styles={twitterStyle} />
        </div>
      ) : null}
    </div>
  )
}

ColorPicker.propTypes = {
  showColorPicker: PropTypes.bool,
  setShowColorPicker: PropTypes.func,
  colors: PropTypes.array,
  color: PropTypes.string,
  setColor: PropTypes.func
}

export default ColorPicker
